<script setup lang="ts">
import { NIcon, NFlex } from "naive-ui"
import { CloudOfflineOutline } from "@vicons/ionicons5"
</script>
<template>
  <aside class="offline-bar" role="status" aria-live="polite" aria-label="Offline status">
    <n-flex justify="center" align="center">
      <n-icon size="25" aria-hidden="true"><CloudOfflineOutline /></n-icon>
      You are currently offline.
    </n-flex>
  </aside>
</template>
<style>
.offline-bar {
  padding: 6px 12px;
  background-color: #3e92cc;
  color: #000;
}
</style>
